import React, {useRef, useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from 'modules';
import {seekingAction, setPlayingTimeAction, pauseAction} from 'modules/video';
import {
  addCutAction,
  addListsAction,
  // changePlayingIdxCutAction,
  INITIALIZE,
  setStatusCutAction,
  // initializeAction,
  addCutSectionAction,
  setShadeDuration,
  TCutLists,
  addShadesAction,
} from 'modules/cut';
import {setAction, SET} from 'modules/history';
import {setNextSectionAction, selectSectionAction} from 'modules/timeline';
import {
  getProgressBarPostitionByTime,
  getProgressPixelByPosition,
  getProgressBarTimeByHandler,
  getTranslateX,
  // getPixelByTime,
  setAttributes,
  getWidth,
  getStyleLeft,
  convertSecondToTime,
  getProgressBarTimeByPx,
} from 'lib/utils';
// import { FileEntity } from "lib/api/vodInfo";
import {
  // getFileIndexByTime,
  // getTotalDurationByIndex,
  // getHlsCdnSectionPlayUrl,
  getCutListInfo,
  getNextCutFileItem,
  getMaxEndTimeByCutSection,
  getPausedState,
  isLastTimelineSection,
  getSectionPlay,
} from 'lib/playUtils';
import {
  CSS_START_BTN,
  CSS_END_BTN,
  CSS_SELECTED_AREA,
  CSS_SHADES_AREA,
  CSS_BTN_CUT_EDITOR,
  CSS_DISABLED,
  CSS_CLOSE_BTN,
  CSS_BTN_CLEAR_ALL,
  CSS_DIV_BTN,
  CSS_DIV_EDITOR_WRAP,
  CSS_TIMELINE_PLAYHEAD,
} from 'constants/dom';
import useEventListener from 'hooks/useEventListener';
import EditWrap from 'components/edit/EditWrap';
import {SCREEN_WIDTH} from 'constants/config';
import useEditWarn from 'hooks/useEditWarn';
import {t} from 'lib/i18n';

const EDIT_WRAP_CLASS_LIST = [
  CSS_START_BTN,
  CSS_END_BTN,
  CSS_CLOSE_BTN,
  CSS_SELECTED_AREA,
  CSS_SHADES_AREA,
  CSS_DIV_EDITOR_WRAP,
  CSS_TIMELINE_PLAYHEAD,
];

// wrapHover state 초기값
const wrapHoverInitialState = {
  px: 0,
  cssClass: '',
  convertTime: '',
};

type TElementObj = {
  xPos: number;
  oldX: number;
  tpElOffsetX: number;
  cnt: number;
  saveEl: any;
  targetBtn: any;
  selected: HTMLDivElement | null;
  dragging: boolean;
  prevOnoffFlag: boolean;
  flag: boolean;
  direction: string;
  moving_standard_next_w: number;
  moving_standard_next_left: number;
  moving_standard_next_next_left: number;
  moving_standard_prev_left: number;
};
const elementObj: TElementObj = {
  xPos: 0,
  oldX: 0,
  tpElOffsetX: 0,
  cnt: 0,
  saveEl: null,
  targetBtn: null,
  selected: null,
  dragging: false,
  prevOnoffFlag: false,
  flag: false,
  direction: '',
  moving_standard_next_w: 0,
  moving_standard_next_left: 0,
  moving_standard_next_next_left: 0,
  moving_standard_prev_left: 0,
};

const btnCreateName = [
  CSS_START_BTN,
  CSS_END_BTN,
  CSS_CLOSE_BTN,
  CSS_BTN_CLEAR_ALL,
];
const divCreateName = [
  `${CSS_SHADES_AREA} first`,
  CSS_SELECTED_AREA,
  `${CSS_SHADES_AREA} last`,
  CSS_SHADES_AREA,
];

let beforeCutIdx = 0; // 컷 편집한 영역 재생 이전 idx 값

/**
 * 편집 하는 영역 컨테이너
 */
const EditWrapContainer = () => {
  const dispatch = useDispatch();
  const {
    fileList,
    playingTime,
    videoDOM,
    paused,
    cut,
    history,
    timeline: {sectionIdx, sectionLists},
    editMode,
  } = useSelector(({file, video, cut, history, timeline, ui}: RootState) => ({
    fileList: file.list,
    playingTime: video.playingTime,
    videoDOM: video.videoDOM,
    paused: video.paused,
    totalDuration: video.totalDuration,
    cut,
    history,
    timeline,
    editMode: ui.editMode,
  }));

  const wrapRef = useRef<HTMLDivElement>(null); // .div_editor_wrap
  const innerRef = useRef<HTMLDivElement>(null); // .div_editor_inner
  const hoverRef = useRef<HTMLDivElement>(null); // .timeline_hover_line
  const playHeadRef = useRef<HTMLDivElement>(null); // .timeline_playhead
  const flowRef = useRef<HTMLDivElement>(null); // .timeline_flow
  const [playHead, setPlayHead] = useState({
    cssClass: '',
    transX: 0,
  });
  const [flowHead, setFlowHead] = useState({
    left: 0,
  });
  // wrap 영역 마우스 오버 시, UI/시간 상태
  const [wrapHover, setWrapHover] = useState(wrapHoverInitialState);
  const [drag, setDrag] = useState(false); // 프로그레스바 드래그 상태

  // const [shadeStyle, setShadeStyle] = useState({}); // 그림자 영역 스타일
  const [divideBtn, setDivideBtn] = useState(CSS_DISABLED); // 분할 버튼 활성화/비활성화 상태
  const displayEditWarn = useEditWarn(
    editMode,
    sectionIdx,
    cut.sectionNode,
    cut.lists,
  ); // 구간 선택 안내 문구 표시

  useEffect(() => {
    if (!playHeadRef.current) return;
    if (!wrapRef.current) return;

    let playHeadTransX = 0;
    if (playHeadRef.current) {
      playHeadTransX = getTranslateX(playHeadRef.current);
    }
    const sectionStime = sectionLists[sectionIdx].startTime;
    const sectionEtime = sectionLists[sectionIdx].endTime;
    const playHeadTime = getProgressBarTimeByPx(
      playHeadTransX,
      getWidth(wrapRef.current),
      sectionStime,
      sectionEtime,
    );
    const {shadeArea} = getCutListInfo(
      cut.lists[sectionIdx],
      playHeadTime,
      sectionIdx,
    );
    if (shadeArea) {
      setDivideBtn(CSS_DISABLED);
    } else {
      setDivideBtn('');
    }
  }, [cut.lists]);

  /**
   * Media timeupdate Event
   * playingTime은 전체 파일 기준의 시간
   */
  useEffect(() => {
    // seeking했으면 seeking한 playingTime이 옴
    // if (!cut.status) return;
    if (!sectionLists[sectionIdx]) return;
    if (!videoDOM) return;

    const isMediaPaused = getPausedState(videoDOM);

    if (
      sectionLists[sectionIdx].startTime > playingTime &&
      sectionIdx + 1 >= sectionLists.length
    ) {
      // 현재 섹션의 startTime이 재생시간보다 클 경우에는 처음 섹션으로 돌림
      // 마지막 섹션인지 여부 추가(미디어 시간이 섹션별 시간보다 작거나 클 수 있으므로)
      dispatch(selectSectionAction(0));
      return;
    }

    drawPlayingBar(playingTime); // playhead 그림

    if (sectionLists[sectionIdx].endTime < playingTime) {
      // 다음 섹션 넘어 갔을 경우
      if (isLastTimelineSection(sectionLists.length, sectionIdx)) {
        // 마지막 섹션일 경우 그냥 리턴
        return;
      }
      setDispatchSection(cut.lists, sectionIdx, editMode);
      return;
    }

    if (!cut.lists[sectionIdx]) {
      // 섹션 구간에 컷 편집한 내용 없을 경우에는 아래 seeking로직 안타고 일반 재생 하듯이 시킴
      drawPlayingBar(playingTime); // playhead 그림
      return;
    }

    const maxEndTime = getMaxEndTimeByCutSection(cut.lists[sectionIdx]);
    if (maxEndTime <= 0) return;
    if (maxEndTime < playingTime) {
      // 마지막 편집한 시간이 다음 섹션 넘어 갔을 경우
      if (
        !isMediaPaused &&
        !isLastTimelineSection(sectionLists.length, sectionIdx)
      ) {
        // 미디어 재생 중이고, 마지막 섹션이 아닐 경우에는 다음 섹션으로 넘어감
        // (미디어 정지 상태에서 마지막 섹션이면 seeking후 프리뷰 효과 내고, 분할 버튼 비활성화)
        setDispatchSection(cut.lists, sectionIdx, editMode);

        return;
      }
    }

    const {idx, startTime, endTime, duration} = getCutListInfo(
      cut.lists[sectionIdx],
      playingTime,
      sectionIdx,
    );

    let nextIdx = idx;

    if (beforeCutIdx > idx) {
      // 현재 컷 편집 영역 재생 끝나면 다음 컷 편집 영역 재생시켜야하는데 getCutListInfo함수에서 재생 시간 값 계산할 때 끝나면 0으로옴
      // 이전에 재생 cutIdx 저장하고 있다가 이전값이 더 클 경우엔 다음꺼 재생시키도록 함
      nextIdx = beforeCutIdx;
    }
    beforeCutIdx = idx;

    // if (shadeArea) {
    //     // 그림자 영역이면 분할 버튼 비활성화
    //     setDivideBtn(CSS_DISABLED);
    // } else {
    //     setDivideBtn("");
    // }

    if (isMediaPaused) {
      // 미디어 정지상태 + 그림자 영역 seeking했을 때에는 seeking으로 프리뷰이미지만 보이게 함
      // (위 상태에서 재생 시에는 다음 컷 편집 영역부터 시작)
      dispatch(seekingAction(playingTime));
      return;
    }

    if (cut.lists[sectionIdx][cut.cutPlayingIdx].duration <= 0) {
      // 컷 편집 모드에서 컷 내용 없는 경우 일반 재생 시킴
      drawPlayingBar(playingTime); // playhead 그림
      return;
    }

    if (duration === 0 && paused) {
      return;
    }

    if (playingTime < startTime) {
      dispatch(seekingAction(startTime));
      // playingTime = startTime;
    } else if (playingTime > endTime) {
      // 구간 넘은 경우이니, 다음 구간으로 시킹
      const nextFileItem = getNextCutFileItem(nextIdx, cut.lists[sectionIdx]);
      if (nextFileItem.idx === -1) return; // 다음 구간 및 파일 없을 경우 리턴

      dispatch(seekingAction(nextFileItem.startTime));
    }
  }, [playingTime]);

  // 컷 편집 상태 변환
  useEffect(() => {
    // 종료 클릭 시
    if (!cut.status) {
      // 분할 버튼 활성화/비활성화 구분 값 삽입 로직 추가
      if (divideBtn === CSS_DISABLED) elementObj.prevOnoffFlag = true;
      else elementObj.prevOnoffFlag = false;
    } else {
      // 컷 편집 클릭 시
      if (elementObj.prevOnoffFlag) setDivideBtn(CSS_DISABLED);
      else {
        setDivideBtn('');
      }

      if (elementObj.flag === false) {
        createEl(CSS_BTN_CUT_EDITOR);
        elementObj.flag = true;
      }

      if (playHeadRef.current && playHeadRef.current.parentNode) {
        for (const i in playHeadRef.current.parentNode.childNodes) {
          const pNcN = playHeadRef.current.parentNode.childNodes[
            i
          ] as HTMLDivElement;
          if (pNcN.className === CSS_SELECTED_AREA) elementObj.cnt++;
        }
      }
      elementObj.cnt = 0;
    }
  }, [cut.status]);

  useEffect(() => {
    if (cut.type !== INITIALIZE) return;

    // 편집 초기화
    elementObj.flag = false;
    const shadesArea = document.querySelectorAll(`.${CSS_SHADES_AREA}`);
    const selectedArea = document.querySelectorAll(`.${CSS_SELECTED_AREA}`);
    for (const shade of shadesArea) {
      shade.remove();
    }
    for (const selected of selectedArea) {
      selected.remove();
    }
    setPlayHead({
      cssClass: '',
      transX: 0,
    });
    dispatch(setStatusCutAction(true));
  }, [cut.type]);

  /**
   * 실행 취소/재실행
   */
  useEffect(() => {
    if (history.type === '' || history.type === SET) return;
    if (history.present === null) {
      // 처음 부분으로 UNDO 하면 초기화 함
      // dispatch(initializeAction());
      return;
    }

    // UNDO, REDO 일 경우만 아래 로직 태움
    // 기존 #editArea 지우고, 데이터 clone떠서 다시 append
    removeEditArea();
    const clone = history.present.cloneNode(true);
    appendEditArea(clone);

    addCut(true);
  }, [history]);

  /**
   * 섹션 바뀔 때 마다 타는 함수
   */
  useEffect(() => {
    if (!videoDOM) return; // video 태그 null 이면 리턴
    if (!sectionLists[sectionIdx]) return;

    // 섹션 바꼈을 때 해당 섹션의 앞부분으로 강제 seeking시킴
    dispatch(setPlayingTimeAction(sectionLists[sectionIdx].startTime));
    dispatch(seekingAction(sectionLists[sectionIdx].startTime));

    // sectionIdx에 해당하는 배열이 없으면 해당 섹션에 분할 한게 없는 거임
    if (!cut.sectionNode[sectionIdx]) {
      removeEditArea();
      const divCreate = document.createElement('div');
      divCreate.setAttribute('id', 'editArea');
      appendEditArea(divCreate);
      createFirstEl(divCreateName, btnCreateName);
      return;
    }

    removeEditArea();
    const clone = cut.sectionNode[sectionIdx].cloneNode(true);
    appendEditArea(clone);
  }, [sectionIdx]);

  /**
   * 컷 편집한 영역 append 하는 함수
   * @param node #editArea Node
   */
  const appendEditArea = (node: any) => {
    const inner = document.getElementById('inner') as HTMLDivElement;
    inner.appendChild(node);
  };

  /**
   * 컷 편집한 영역 모두 지우는 함수
   */
  const removeEditArea = () => {
    const editArea = document.getElementById('editArea') as HTMLDivElement;
    if (!editArea || editArea.childNodes.length <= 0) return;

    editArea.remove();
  };

  // 컷 편집 엘리먼트 초기화
  const _destroy = () => {
    elementObj.selected = null;
    elementObj.targetBtn = null;
    elementObj.dragging = false;
    elementObj.moving_standard_next_w = 0;
    elementObj.moving_standard_next_left = 0;
    elementObj.moving_standard_next_next_left = 0;
    elementObj.moving_standard_prev_left = 0;
  };

  // 컷 편집 엘리먼트 삭제
  const removeElFn = (el: any) => {
    let previousEl = el.parentNode.previousElementSibling;
    let nextEl = el.parentNode.nextElementSibling;
    const parentEl = el.parentNode;

    if (el.className === CSS_CLOSE_BTN) {
      if (!playHeadRef.current) return;

      const tplEl = playHeadRef.current;
      while (
        previousEl &&
        previousEl.nodeType !== 1 &&
        previousEl &&
        previousEl.nodeType !== 1
      ) {
        previousEl = previousEl.previousElementSibling;
        nextEl = nextEl.nextElementSibling;
      }
      if (previousEl || nextEl || parentEl) {
        // 삭제 될 엘리먼트랄 현재 타겟이랑 비교 후 일치 시 타겟을 보내고 삭제 수행 아니면 그냥 삭제
        if (elementObj.saveEl === nextEl) elementObj.saveEl = previousEl;

        if (
          parentEl.getBoundingClientRect().left - 5 <
            tplEl.getBoundingClientRect().left &&
          nextEl.getBoundingClientRect().left + nextEl.clientWidth >
            tplEl.getBoundingClientRect().left
        ) {
          elementObj.saveEl = previousEl;
          setDivideBtn('');
        }

        const selectedAreaReSizeW = Number(
          nextEl.getBoundingClientRect().left +
            nextEl.clientWidth -
            previousEl.getBoundingClientRect().left,
        );
        previousEl.style.width = selectedAreaReSizeW + 'px';

        nextEl.parentNode.removeChild(nextEl); // selected_area 제거
        // 초기화 버튼 비활성화 로직 추가
        for (let i = 0; i < parentEl.parentNode.childNodes.length; i++) {
          if (parentEl.parentNode.childNodes[i].className === CSS_SELECTED_AREA)
            elementObj.cnt++;
        }
        if (elementObj.cnt <= 1) {
          // 초기화 버튼 비활성화 추가해야함
          // document.querySelector('.btn_clear_all').classList.add('btn_disabled')
        }
        elementObj.cnt = 0;
        parentEl.remove(parentEl); // selected_area 제거
      }
    }
    // else if (el.className === CSS_BTN_CLEAR_ALL) {
    //     const el_shades = document.getElementsByClassName("shades_area");
    //     const el_select = document.getElementsByClassName("selected_area");
    //     const shades_cnt = el_shades.length;
    //     const select_cnt = el_select.length;

    //     for (let i = 0; i < shades_cnt; i++) el_shades[0].remove();
    //     for (let ii = 0; ii < select_cnt; ii++) el_select[0].remove();

    //     setPlayHead({
    //         ...playHead,
    //         cssClass: "",
    //     });
    //     el.classList.add("btn_disabled"); // 20191018 v.1.0.0 초기화 비활성화 추가
    //     createEl(CSS_BTN_CUT_EDITOR); // 20191018 v.1.0.0 엘리먼트 초기화 후 엘리먼트 생성 함수 호출
    // }
    else {
      setPlayHead({
        ...playHead,
        cssClass: '',
      });
    }
  };

  // 각 섹션별 최초 컷 편집이면 element 생성해줌
  const createFirstEl = (divCreateName: string[], btnCreateName: string[]) => {
    const parentEl = document.getElementById('editArea');
    if (!parentEl) return;

    divCreateName.forEach((val) => {
      const divCreate = document.createElement('div');
      if (val === `${CSS_SHADES_AREA} first`) {
        setAttributes(divCreate, {
          class: `${val}`,
          style: 'left: 0px;',
        });
      } else if (val === `${CSS_SELECTED_AREA}`) {
        setAttributes(divCreate, {
          class: `${val}`,
          'data-index': '0',
          style: 'left: 0px; right: 0px;',
        });
      } else if (val === `${CSS_SHADES_AREA} last`) {
        setAttributes(divCreate, {
          class: `${val}`,
          style: 'right: 0px;',
        });
      } else {
        return;
      }
      parentEl.appendChild(divCreate);
    });

    btnCreateName.forEach((value) => {
      const btnCreate = document.createElement('button');

      if (value === CSS_START_BTN) {
        setAttributes(btnCreate, {class: `${value}`});
        const shadesAreaLast = document.querySelector(
          `.${CSS_SHADES_AREA}.last`,
        );
        if (!shadesAreaLast) return;
        shadesAreaLast.appendChild(btnCreate);
      } else if (value === CSS_END_BTN) {
        setAttributes(btnCreate, {class: `${value}`});
        const shadesAreaFirst = document.querySelector(
          `.${CSS_SHADES_AREA}.first`,
        );
        if (!shadesAreaFirst) return;
        shadesAreaFirst.appendChild(btnCreate);
      } else {
        return;
      }
    });
    elementObj.saveEl = document.querySelector(`.${CSS_SELECTED_AREA}`);
  };

  // 컷 편집 엘리먼트 생성
  const createEl = (name: string) => {
    // 컷 편집 최초 클릭 시 엘리먼트 생성
    if (name === CSS_BTN_CUT_EDITOR) {
      removeEditArea(); // 페이지 로드 후 바로 다음 섹션 넘어가고 컷 편집 최초 클릭 했을 때 중복으로 엘리먼트 생기는 이슈 땜에 넣음
      createFirstEl(divCreateName, btnCreateName);
      // setDivideBtn(""); // 최초 컷 편집 클릭 시 분할 버튼 활성화
    } else if (name === CSS_DIV_BTN) {
      if (!wrapRef.current) return;
      const trackEl = wrapRef.current;

      // 분할 클릭 시 엘리먼트 생성
      divCreateName.forEach((val) => {
        const divCreate = document.createElement('div');
        if (val === CSS_SHADES_AREA) {
          setAttributes(divCreate, {
            class: `${val}`,
            style: `width: 0px; left: ${
              elementObj.tpElOffsetX - trackEl.getBoundingClientRect().left
            }px;`,
          });
        } else if (val === CSS_SELECTED_AREA) {
          if (!elementObj.saveEl) return;
          if (elementObj.saveEl.nextElementSibling !== null) {
            setAttributes(divCreate, {
              class: `${val}`,
              style: `left: ${
                elementObj.tpElOffsetX - trackEl.getBoundingClientRect().left
              }px; width: ${
                elementObj.saveEl.getBoundingClientRect().left +
                elementObj.saveEl.clientWidth -
                elementObj.tpElOffsetX
              }px;`,
            });
          } else {
            // 이전 셀렉트에어리어 넓이 값 - ( 분할 클릭 위치 - 선택된 셀렉트에어리어 레프트값 )
            setAttributes(divCreate, {
              class: `${val}`,
              style: `left: ${
                elementObj.tpElOffsetX - trackEl.getBoundingClientRect().left
              }px; width: ${
                elementObj.saveEl.clientWidth -
                (elementObj.tpElOffsetX -
                  trackEl.getBoundingClientRect().left -
                  elementObj.saveEl.offsetLeft)
              }px;`,
            });
          }
        } else {
          return;
        }

        // if (!elementObj.saveEl) return;
        if (elementObj.saveEl.parentNode !== null) {
          elementObj.saveEl.parentNode.insertBefore(
            divCreate,
            elementObj.saveEl.nextElementSibling,
          );
        } else {
          if (!innerRef.current) return;
          innerRef.current.insertBefore(
            divCreate,
            elementObj.saveEl.nextElementSibling,
          );
        }
      });

      btnCreateName.forEach((value) => {
        const btnCreate = document.createElement('button');
        if (value === CSS_START_BTN) {
          setAttributes(btnCreate, {
            class: `${value}`,
            style: 'left: -4px',
          });
        } else if (value === CSS_END_BTN) {
          setAttributes(btnCreate, {
            class: `${value}`,
            style: 'right: -4px',
          });
        } else if (value === CSS_CLOSE_BTN) {
          setAttributes(btnCreate, {class: `${value}`});
        } else {
          return;
        }
        elementObj.saveEl.nextElementSibling.appendChild(btnCreate);
      });
      setDivideBtn(CSS_DISABLED); // 분할 비활성화
      selectElResize(elementObj.saveEl);
    }
  };

  // 타켓 스위칭 함수
  const switchTargetFn = (newTarget: any) => {
    if (!newTarget) return;

    if (newTarget.parentNode.nextElementSibling !== null) {
      // elementObj.moving_standard_next = newTarget.parentNode.nextElementSibling
      elementObj.moving_standard_next_w =
        newTarget.parentNode.nextElementSibling.clientWidth;
      elementObj.moving_standard_next_left = Number(
        newTarget.parentNode.nextElementSibling.offsetLeft,
      );

      if (newTarget.parentNode.nextElementSibling.nextElementSibling !== null) {
        // elementObj.moving_standard_next_next = newTarget.parentNode.nextElementSibling.nextElementSibling
        // elementObj.moving_standard_next_next_w = newTarget.parentNode.nextElementSibling.nextElementSibling.clientWidth
        elementObj.moving_standard_next_next_left = Number(
          newTarget.parentNode.nextElementSibling.nextElementSibling.offsetLeft,
        );
      }
    } else {
      if (!wrapRef.current) return;
      elementObj.moving_standard_next_left = Number(
        wrapRef.current.clientWidth,
      );
    }

    if (newTarget.parentNode.previousElementSibling !== null) {
      // elementObj.moving_standard_prev = newTarget.parentNode.previousElementSibling
      // elementObj.moving_standard_prev_w = newTarget.parentNode.previousElementSibling.clientWidth
      elementObj.moving_standard_prev_left = Number(
        newTarget.parentNode.previousElementSibling.offsetLeft,
      );

      if (
        newTarget.parentNode.previousElementSibling.previousElementSibling !==
        null
      ) {
        // elementObj.moving_standard_prev_prev = newTarget.parentNode.previousElementSibling.previousElementSibling
        // elementObj.moving_standard_prev_prev_w = newTarget.parentNode.previousElementSibling.previousElementSibling.clientWidth
        // elementObj.moving_standard_prev_prev_left = Number( newTarget.parentNode.previousElementSibling.previousElementSibling.offsetLeft )
      }
    }
  };

  const selectElResize = (target: any) => {
    if (!wrapRef.current) return;
    const trackEl = wrapRef.current;

    if (target.classList[0] === CSS_SELECTED_AREA) {
      target.style.width =
        Number(
          elementObj.tpElOffsetX -
            trackEl.getBoundingClientRect().left -
            (target.getBoundingClientRect().left -
              trackEl.getBoundingClientRect().left),
        ) + 'px';
    }
  };

  // 분할 노출/비노출 영역 지정
  const divBtnShowFn = () => {
    if (!elementObj.selected) {
      if (!playHeadRef.current) return;
      if (!playHeadRef.current.classList[1]) return;
      setDivideBtn('');
    } else {
      if (!elementObj.targetBtn) return;
      if (!elementObj.targetBtn.parentNode) return;
      if (!playHeadRef.current) return;
      if (
        Number(elementObj.tpElOffsetX) < Number(elementObj.selected.offsetLeft)
      ) {
        setDivideBtn(CSS_DISABLED);
      } else if (
        elementObj.targetBtn.parentNode.classList[0] === CSS_SELECTED_AREA &&
        elementObj.targetBtn.className === CSS_START_BTN &&
        elementObj.tpElOffsetX < elementObj.xPos
      ) {
        setDivideBtn(CSS_DISABLED);
      } else if (
        elementObj.targetBtn.parentNode.classList[0] === CSS_SELECTED_AREA &&
        elementObj.targetBtn.className === CSS_END_BTN &&
        elementObj.tpElOffsetX > elementObj.xPos
      ) {
        setDivideBtn(CSS_DISABLED);
      } else if (playHeadRef.current.classList[1] === undefined) {
        // playhead playhead_visible 클래스 체크
        return;
      } else {
        if (!playHeadRef.current) return;
        if (!wrapRef.current) return;

        let playHeadTransX = 0;
        if (playHeadRef.current) {
          playHeadTransX = getTranslateX(playHeadRef.current);
        }
        const sectionStime = sectionLists[sectionIdx].startTime;
        const sectionEtime = sectionLists[sectionIdx].endTime;
        const playHeadTime = getProgressBarTimeByPx(
          playHeadTransX,
          getWidth(wrapRef.current),
          sectionStime,
          sectionEtime,
        );
        const {shadeArea} = getCutListInfo(
          cut.lists[sectionIdx],
          playHeadTime,
          sectionIdx,
        );
        if (shadeArea) {
          setDivideBtn(CSS_DISABLED);
        } else {
          console.log('qwewqeqwe: ');
          setDivideBtn('');
        }
      }
    }
  };

  /**
   * 타임라인 영역에 마우스 오버하면 해당 마우스 위치 값으로 시간 가져옴
   */
  const getTimeByHandler = (
    e: MouseEvent | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    if (!wrapRef.current) return 0;
    // if (!sectionLists[sectionIdx]) return -1;

    const time = getProgressBarTimeByHandler(
      e,
      wrapRef.current,
      sectionLists[sectionIdx].startTime,
      sectionLists[sectionIdx].endTime,
    );
    return time;
  };

  // 선택영역 드레그시  분할 버튼 활성 비활성
  const timelineHead = (
    start_position: string,
    mouse_direction: string,
    element_target: any,
  ) => {
    if (!playHeadRef.current) return;
    if (!element_target) {
      console.warn('@@@ element_target ERROR');
      return;
    }
    // if (!element_target.parentNode) {
    //     console.warn("@@@ element_target.parentNode ERROR");
    //     return;
    // }
    if (!element_target.parentNode.previousElementSibling) {
      console.warn(
        '@@@ element_target.parentNode.previousElementSibling ERROR',
      );
      return;
    }
    if (!element_target.parentNode.nextElementSibling) {
      console.warn('@@@ element_target.parentNode.nextElementSibling ERROR');
      return;
    }

    const tplEl = playHeadRef.current;
    if (
      element_target.parentNode.previousElementSibling.getBoundingClientRect()
        .left < tplEl.getBoundingClientRect().left &&
      element_target.parentNode.getBoundingClientRect().left +
        element_target.parentNode.clientWidth >
        tplEl.getBoundingClientRect().left
    ) {
      if (
        start_position === CSS_START_BTN &&
        elementObj.direction === 'right'
      ) {
        if (
          element_target.parentNode.previousElementSibling.getBoundingClientRect()
            .left +
            element_target.parentNode.previousElementSibling.clientWidth >
          tplEl.getBoundingClientRect().left + 4
        ) {
          setDivideBtn('');
          elementObj.saveEl = element_target.parentNode.previousElementSibling;
        }
      } else if (
        start_position === CSS_START_BTN &&
        elementObj.direction === 'left'
      ) {
        if (
          element_target.parentNode.previousElementSibling.getBoundingClientRect()
            .left +
            element_target.parentNode.previousElementSibling.clientWidth <
          tplEl.getBoundingClientRect().left
        ) {
          setDivideBtn(CSS_DISABLED);
        }
      }
    }

    if (
      element_target.parentNode.getBoundingClientRect().left <
        tplEl.getBoundingClientRect().left &&
      element_target.parentNode.nextElementSibling.getBoundingClientRect()
        .left +
        element_target.parentNode.nextElementSibling.clientWidth >
        tplEl.getBoundingClientRect().left
    ) {
      if (start_position === CSS_END_BTN && elementObj.direction === 'left') {
        if (
          element_target.parentNode.nextElementSibling.getBoundingClientRect()
            .left <
          tplEl.getBoundingClientRect().left + 4
        ) {
          setDivideBtn('');
          elementObj.saveEl = element_target.parentNode.nextElementSibling;
        }
      } else if (
        start_position === CSS_END_BTN &&
        elementObj.direction === 'right'
      ) {
        if (
          element_target.parentNode.nextElementSibling.getBoundingClientRect()
            .left > tplEl.getBoundingClientRect().left
        ) {
          setDivideBtn(CSS_DISABLED);
        }
      }
    }
  };

  /**
   * Pixel 계산 함수
   * @param time seconds
   */
  const getPixel = (time: number) => {
    if (!wrapRef.current) return 0;
    if (!sectionLists[sectionIdx]) return 0;

    // 총 시간에 비례한 현재 재생 시간 % 값 얻어옴
    // const percent = getProgressBarPostitionByTime(time, duration);
    // // 현재 재생시간 %를 pixel로 변환
    // const px = getProgressPixelByPosition(wrapRef.current, percent);

    const sectionTime = time - sectionLists[sectionIdx].startTime; // 현재 섹션의 시간 값
    const sectionDuration =
      sectionLists[sectionIdx].endTime - sectionLists[sectionIdx].startTime; // 현재 섹션의 duration

    const percent = getProgressBarPostitionByTime(sectionTime, sectionDuration);

    const px = getProgressPixelByPosition(wrapRef.current, percent);

    return px;
  };

  /**
   * 시간 값에 따른 재생 프로그레스 바 그림
   * @param time seconds
   */
  const drawPlayingBar = (time: number) => {
    const px = getPixel(time);
    // setPlayHead({
    //     cssClass: "playhead_visible",
    //     transX: px,
    // });

    setFlowHead({
      left: px,
    });
  };

  /**
   * 시간 값에 따른 마우스 hoverline 그림
   * @param time seconds
   */
  const drawHoverLine = (time: number) => {
    const px = getPixel(time);
    setWrapHover({
      px: px,
      cssClass: 'hovered',
      convertTime: convertSecondToTime(time),
    });
  };

  /**
   * hoverline 초기화 함수
   */
  const initHoverLine = () => {
    setWrapHover({
      ...wrapHoverInitialState,
    });
  };

  /**
   * 분할 클릭
   */
  const onClickDivision = () => {
    // 분할 버튼이 비활성화 상태면 리턴
    if (divideBtn === CSS_DISABLED) return;

    createEl(CSS_DIV_BTN); // 엘리먼트 생성
  };

  // 편집 wrap 영역에 마우스 무브 시, UI/시간 상태 값 업데이트
  const onMouseMove = (e: MouseEvent) => {
    if (!wrapRef.current) return;
    if (!e.target) return;

    let mode = 'player';
    if (elementObj.dragging) mode = 'edit';

    // let playHeadTransX = 0;
    // if (playHeadRef.current) {
    //     playHeadTransX = getTranslateX(playHeadRef.current);
    // }

    const time = getTimeByHandler(e);
    // if (time === -1) return;
    const {classList} = e.target as Element;

    // if (classList[0] === "timeline_playhead") {
    //     // hoverline이 playhead랑 겹치면 안그림
    //     initHoverLine();
    // } else {
    //     // Mouse Hover
    //     drawHoverLine(time); // 마우스 오버 시 라인 그림
    // }
    if (
      (classList[0] === CSS_DIV_EDITOR_WRAP ||
        classList[0] === CSS_SHADES_AREA ||
        classList[0] === CSS_SELECTED_AREA) &&
      !elementObj.dragging
    ) {
      // Mouse Hover
      drawHoverLine(time); // 마우스 오버 시 라인 그림
    } else {
      initHoverLine();
    }

    switch (mode) {
      case 'player':
        if (drag) {
          initHoverLine();
          // 편집 드래그 영역과 사이드 나서 주석
          // drawPlayingBar(time);
        }
        break;
      case 'edit': {
        if (!cut.status) return;

        elementObj.xPos = e.clientX;
        const mouseMove = Number(
          elementObj.xPos - wrapRef.current.getBoundingClientRect().left,
        ); // 실제 클릭후 이동되는 마우스 값

        if (!elementObj.selected) return;

        if (!elementObj.targetBtn) return;
        // if (!elementObj.targetBtn.parentNode) return;

        let selectBtn = CSS_START_BTN;
        if (elementObj.targetBtn.className === CSS_START_BTN) {
          if (
            elementObj.oldX === 0 ||
            elementObj.targetBtn.parentNode.previousElementSibling === null
          ) {
            elementObj.oldX = e.pageX - 1;
          }
          const next_element =
            elementObj.targetBtn.parentNode.getBoundingClientRect().left +
            elementObj.targetBtn.parentNode.clientWidth;
          if (e.pageX <= elementObj.oldX) {
            // 선택영역 감소
            elementObj.direction = 'left';
            if (
              Number(
                elementObj.targetBtn.parentNode.previousElementSibling.getBoundingClientRect()
                  .left,
              ) >= elementObj.xPos
            ) {
              const child_cnt = !(
                elementObj.targetBtn.parentNode.previousElementSibling
                  .previousElementSibling.childNodes.length == 3
              )
                ? 0
                : 1;

              elementObj.targetBtn.parentNode.style.width =
                Number(
                  elementObj.moving_standard_next_left -
                    elementObj.moving_standard_prev_left,
                ) + 'px';
              elementObj.targetBtn.parentNode.style.left =
                Number(elementObj.moving_standard_prev_left) + 'px';
              elementObj.targetBtn =
                elementObj.targetBtn.parentNode.previousElementSibling.previousElementSibling.childNodes[
                  child_cnt
                ];

              switchTargetFn(elementObj.targetBtn);
              return;
            } else {
              elementObj.targetBtn.parentNode.style.left = mouseMove + 'px';
              elementObj.targetBtn.parentNode.style.width =
                Number(next_element - elementObj.xPos) + 'px';
              elementObj.targetBtn.parentNode.previousElementSibling.style.width =
                Number(
                  elementObj.xPos -
                    elementObj.targetBtn.parentNode.previousElementSibling.getBoundingClientRect()
                      .left,
                ) + 'px';
            }
          } else if (e.pageX > elementObj.oldX) {
            // 선택영역 증가
            elementObj.direction = 'right';

            if (next_element <= elementObj.xPos) {
              // 2020-0129
              if (elementObj.targetBtn.nextElementSibling === null) {
                if (elementObj.xPos >= SCREEN_WIDTH - 20) {
                  elementObj.targetBtn.parentNode.style.width = '0px';
                  elementObj.targetBtn.parentNode.style.left =
                    Number(
                      elementObj.targetBtn.parentNode.parentNode.clientWidth,
                    ) + 'px';
                }
              }

              elementObj.targetBtn.parentNode.style.left =
                Number(elementObj.moving_standard_next_left) + 'px';
              elementObj.targetBtn.parentNode.previousElementSibling.style.width =
                Number(
                  elementObj.moving_standard_next_left -
                    elementObj.moving_standard_prev_left,
                ) + 'px';

              // 2020-0128 마지막 엘리먼트 선택 수정
              if (elementObj.targetBtn.nextElementSibling === null) {
                return;
              } else {
                elementObj.targetBtn = elementObj.targetBtn.nextElementSibling;
              }
              switchTargetFn(elementObj.targetBtn);
            }
            // //2020-0114 무빙 이슈 수정 추가
            else {
              elementObj.targetBtn.parentNode.style.left = mouseMove + 'px';
              elementObj.targetBtn.parentNode.style.width =
                Number(next_element - elementObj.xPos) + 'px';
              elementObj.targetBtn.parentNode.previousElementSibling.style.width =
                Number(
                  elementObj.xPos -
                    elementObj.targetBtn.parentNode.previousElementSibling.getBoundingClientRect()
                      .left,
                ) + 'px';
            }
          }
          elementObj.oldX = e.pageX;
        } else if (elementObj.targetBtn.className === CSS_END_BTN) {
          selectBtn = CSS_END_BTN;
          if (e.pageX < elementObj.oldX) {
            // 선택영역 증가
            elementObj.direction = 'left';
            // 2020-0114 무빙 이슈 수정 추가
            if (
              elementObj.targetBtn.parentNode.getBoundingClientRect().left >=
              elementObj.xPos
            ) {
              elementObj.targetBtn.parentNode.style.width = Number(0) + 'px';
              elementObj.targetBtn.parentNode.nextElementSibling.style.left =
                Number(elementObj.targetBtn.parentNode.offsetLeft) + 'px';
              elementObj.targetBtn.parentNode.nextElementSibling.style.width =
                Number(
                  elementObj.moving_standard_next_next_left -
                    elementObj.targetBtn.parentNode.offsetLeft,
                ) + 'px';

              // 2020-0128 첫 엘리먼트 선택 수정
              if (elementObj.targetBtn.previousElementSibling === null) {
                return;
              } else {
                elementObj.targetBtn =
                  elementObj.targetBtn.previousElementSibling;
              }
              switchTargetFn(elementObj.targetBtn);
            } else {
              elementObj.targetBtn.parentNode.style.width =
                Number(
                  elementObj.xPos -
                    elementObj.targetBtn.parentNode.getBoundingClientRect()
                      .left,
                ) + 'px';
              elementObj.targetBtn.parentNode.nextElementSibling.style.left =
                Number(mouseMove) + 'px';
              elementObj.targetBtn.parentNode.nextElementSibling.style.width =
                Number(
                  elementObj.targetBtn.parentNode.nextElementSibling.nextElementSibling.getBoundingClientRect()
                    .left - elementObj.xPos,
                ) + 'px';
            }
          } else if (e.pageX > elementObj.oldX) {
            // 선택영역 감소
            elementObj.direction = 'right';
            if (
              Number(
                elementObj.targetBtn.parentNode.nextElementSibling.nextElementSibling.getBoundingClientRect()
                  .left,
              ) <= elementObj.xPos
            ) {
              elementObj.targetBtn.parentNode.style.width =
                Number(
                  elementObj.moving_standard_next_next_left -
                    elementObj.targetBtn.parentNode.offsetLeft,
                ) + 'px';
              elementObj.targetBtn.parentNode.nextElementSibling.style.left =
                Number(elementObj.moving_standard_next_next_left) + 'px';
              elementObj.targetBtn =
                elementObj.targetBtn.parentNode.nextElementSibling.nextElementSibling.childNodes[0];

              switchTargetFn(elementObj.targetBtn);
            } else {
              elementObj.targetBtn.parentNode.style.width =
                Number(
                  elementObj.xPos -
                    elementObj.targetBtn.parentNode.getBoundingClientRect()
                      .left,
                ) + 'px';
              elementObj.targetBtn.parentNode.nextElementSibling.style.left =
                Number(
                  elementObj.xPos -
                    wrapRef.current.getBoundingClientRect().left,
                ) + 'px';
              elementObj.targetBtn.parentNode.nextElementSibling.style.width =
                Number(
                  elementObj.targetBtn.parentNode.nextElementSibling.nextElementSibling.getBoundingClientRect()
                    .left - elementObj.xPos,
                ) + 'px';
            }
          }
          elementObj.oldX = e.pageX;
        }
        timelineHead(selectBtn, elementObj.direction, elementObj.targetBtn);

        break;
      }
      default:
        break;
    }
  };
  // mouseleave 이벤트
  const onMouseLeave = () => {
    initHoverLine();
  };
  // mousedown 이벤트
  const onMouseDown = (e: MouseEvent) => {
    const eTarget = e.target as HTMLDivElement | HTMLButtonElement;
    const eTargetClass = eTarget.className;
    const eTargetClassList = eTarget.classList[0];
    const xPos1 = e.clientX;

    if (EDIT_WRAP_CLASS_LIST.indexOf(eTargetClassList) < 0) {
      // 편집 영역 mousedown 아니면 리턴(document영역이라 중복방지)
      return;
    }

    elementObj.targetBtn = eTarget as HTMLDivElement | HTMLButtonElement;
    elementObj.selected = document.querySelector(`.${CSS_SELECTED_AREA}`);

    // elementObj.saveEl = element;

    if (eTargetClass === CSS_START_BTN || eTargetClass === CSS_END_BTN) {
      // 편집 영역 드래그
      elementObj.targetBtn = eTarget;
      elementObj.dragging = true;

      // //2020-0123 무빙 시 박스 리사이징 이슈로 인해 수정
      if (elementObj.targetBtn.parentNode.nextElementSibling !== null) {
        elementObj.moving_standard_next_w =
          elementObj.targetBtn.parentNode.nextElementSibling.clientWidth;
        elementObj.moving_standard_next_left = Number(
          elementObj.targetBtn.parentNode.nextElementSibling.offsetLeft,
        );

        if (
          elementObj.targetBtn.parentNode.nextElementSibling
            .nextElementSibling !== null
        ) {
          elementObj.moving_standard_next_next_left = Number(
            elementObj.targetBtn.parentNode.nextElementSibling
              .nextElementSibling.offsetLeft,
          );
        }
      } else {
        if (!wrapRef.current) return;
        elementObj.moving_standard_next_left = Number(
          wrapRef.current.clientWidth,
        );
      }

      if (elementObj.targetBtn.parentNode.previousElementSibling !== null) {
        elementObj.moving_standard_prev_left = Number(
          elementObj.targetBtn.parentNode.previousElementSibling.offsetLeft,
        );
      }
    } else if (eTargetClass === CSS_CLOSE_BTN) {
      removeElFn(eTarget);
      addCut();
    } else if (
      eTargetClassList === CSS_SELECTED_AREA ||
      eTargetClassList === CSS_SHADES_AREA ||
      eTarget.classList[0] === 'div_editor_wrap'
    ) {
      if (!wrapRef.current) return;

      if (eTargetClassList === CSS_SELECTED_AREA) {
        setDivideBtn('');
      } else {
        setDivideBtn(CSS_DISABLED);
      }
      const time = getTimeByHandler(e);
      // if (time === -1) return;
      // const { shadeArea } = getCutListInfo(
      //     cut.lists[sectionIdx],
      //     time,
      //     sectionIdx,
      // );
      // if (shadeArea) return;

      elementObj.tpElOffsetX = xPos1;
      elementObj.saveEl = eTarget;

      setPlayHead({
        cssClass: 'playhead_visible',
        transX:
          elementObj.tpElOffsetX - wrapRef.current.getBoundingClientRect().left,
      });

      if (cut.status) {
        // 컷 편집 상태 true
        // const { idx, duration } = getCutListInfo(cut.lists, time);
        // let cutIdx = idx;
        // if (duration <= 0) {
        //     // 첫 컷 편집 상태(아무것도 수정안한 초기화 상태)
        //     cutIdx = 0;
        // }
        // dispatch(changePlayingIdxCutAction(cutIdx));
        divBtnShowFn();
      }

      // 20191030 v.1.0.0 쉐이드영역에 클릭 가능 / 분할 버튼 활성화/비활성화 구분 값 초기화
      if (eTargetClassList === CSS_SHADES_AREA) {
        setDivideBtn(CSS_DISABLED);
        elementObj.prevOnoffFlag = true;
      } else {
        elementObj.prevOnoffFlag = false;
      }

      // seeking dispatch
      // 마우스 클릭 seeking 시에 제일 처음 time 넣음
      dispatch(seekingAction(time));
    } else if (eTarget.classList[0] === CSS_BTN_CUT_EDITOR) {
      // 20191030 v.1.0.0 컷 편집 / 종료 로직 추가
      // if (eTarget.classList[1] === CSS_BTN_CUT_EDITOR_CLOSE && eTarget.classList[1] !== undefined) {
      //     const pN = eTarget.parentNode as HTMLDivElement | HTMLButtonElement;
      //     if (!pN.nextElementSibling) return;
      //     pN.nextElementSibling.nextElementSibling.classList.add()
      // }
    } else if (eTarget.classList[0] === CSS_TIMELINE_PLAYHEAD) {
      // 재생 바 드래그
      setDrag(true);
    }

    // const time = getTimeByHandler(e);
    // const { shadeArea } = getCutListInfo(
    //     cut.lists[sectionIdx],
    //     time,
    //     sectionIdx,
    // );
    // if (shadeArea) {
    //     // 그림자 영역
    //     setDivideBtn(CSS_DISABLED);
    // } else {
    //     setDivideBtn("");
    // }

    // if (!videoDOM) return;

    // const isMediaPaused = getPausedState(videoDOM);
    // if (isMediaPaused) {

    // } else {
    //     setDivideBtn(CSS_DISABLED);
    // }
  };
  // mouseup 이벤트
  const onMouseUp = () => {
    // const time = getTimeByHandler(e);

    if (cut.status) {
      if (!elementObj.dragging) {
        // 컷 편집 상태 + 컷 편집 드래그 아닌 상태
        // let isDivide = false;
        // for (const { startTime, endTime } of cut.lists) {
        //     // 컷 편집 상태들 돌면서 편집 구간 아니면 '분할' 버튼 가능한 구간이면 활성화 시킴
        //     if (time > startTime && time < endTime) {
        //         isDivide = true;
        //         break;
        //     }
        // }
        // if (isDivide) {
        //     setDivideBtn("");
        // } else {
        //     setDivideBtn(CSS_DISABLED);
        // }
      } else {
        addCut();
      }
    }

    _destroy(); // 컷 편집 UI 변수 초기화

    // const element = e.target as HTMLDivElement | HTMLButtonElement;
    // const elementClass = element.className;

    // if (elementClass === CSS_START_BTN || elementClass === CSS_END_BTN) {
    //     // 편집 영역 드래그
    // } else {
    //     // 재생 바 드래그
    // }

    // if (!cutDrag.dragging) {
    //     drawPlayingBar(time);
    // }
    // setCutDrag({
    //     element: null,
    //     className: "",
    //     dragging: false,
    // });
    setDrag(false);

    // if (cut.status) return;

    // dispatch(seekingAction(time));
  };

  /**
   * 컷한 정보 리듀서 스토어에 ADD 하는 함수
   * @param type "remove": 컷 삭제 경우
   * @param isHistroy true: Undo/Redo 경우
   */
  const addCut = (isHistroy = false) => {
    if (!wrapRef.current) return;

    // 컷 편집 시간들 dispatch
    const editArea = document.getElementById('editArea') as HTMLDivElement;
    // div id인 editArea 자식으로 CSS_SELECTED_AREA 클래스 넣는데, 간헐적으로 editArea부모의 자식으로 들어가는 문의가 있었음(마우스 먹힘 현상?)
    // editArea 자식만 체크하도록 변경
    const cutArea = editArea.querySelectorAll(
      `.${CSS_SELECTED_AREA}`,
    ) as NodeListOf<HTMLElement>;

    const playArr = [];
    const listArr = [];
    let totalCutDuration = 0; // 편집한 총 시간(seconds)
    // 섹션 별 구간 타임
    const sectionStime = sectionLists[sectionIdx].startTime;
    const sectionEtime = sectionLists[sectionIdx].endTime;
    for (const el of cutArea) {
      let left = getStyleLeft(el);
      let endTimeWidth = getWidth(el);

      if (editMode === 'section' && endTimeWidth <= 0) {
        // 편집 구간 너비가 0이하 인 경우 = 편집 영역 시작과 끝 시간이 같은 경우
        // 디폴트 2초 +-로 함
        if (left > endTimeWidth) {
          // start_btn을 우측 끝으로 옴겨서 end_btn과 겹칠 경우
          // ex) left: 1750, endTimeWidth: 0 = 1748과 1750으로 만듬
          left -= 2;

          if (left <= 0) left = 0;
          endTimeWidth = left + 2;
        } else {
          // start_btn을 좌측 끝으로 옴겨서 end_btn과 겹칠 경우
          // ex) left: 0, endTimeWidth: 0 = 0과 2로 만듬
          endTimeWidth += 2;
        }
      } else {
        endTimeWidth = left + endTimeWidth;
      }

      const sTime = getProgressBarTimeByPx(
        left,
        getWidth(wrapRef.current),
        sectionStime,
        sectionEtime,
      );
      const eTime = getProgressBarTimeByPx(
        endTimeWidth,
        getWidth(wrapRef.current),
        sectionStime,
        sectionEtime,
      );

      // const sTime = Number(getCutTime(left).toFixed(2)); // 전체 시간 대비 편집 시작 시간
      // const eTime = Number(getCutTime(left + getWidth(el)).toFixed(2)); // 전체 시간 대비 편집 끝 시간

      let startTime = Number(sTime.toFixed(2));
      let endTime = Number(eTime.toFixed(2));
      let duration = Number((eTime - sTime).toFixed(2));

      if (startTime === sectionStime && endTime === sectionEtime) {
        // 컷 편집 초기 상태일 경우(= 처음부터 끝까지 전체 영역인 경우)
        // 0으로 초기화
        startTime = 0;
        endTime = 0;
        duration = 0;
      }

      totalCutDuration += duration;

      // 재생 바 상태에서 컷 편집한 시간 리스트
      listArr.push({
        startTime,
        endTime,
        duration,
      });

      // 구간 재생 정보
      const sectionPlay = getSectionPlay(fileList, sTime, eTime);
      // sectionPlay는 max 2개
      for (let i = 0; i < sectionPlay.length; i++) {
        sectionPlay[i].cutIdx = i;
        playArr.push(sectionPlay[i]);
      }
    }
    // if (type === "remove") {
    //     // shade영역 제거 할 시에는 cut정보 배열들 초기화 후 다시 ADD
    //     dispatch(initInfoListAction());
    // }

    // 현재 섹션 기준, 컷 편집 하고 남은 영역(그림자 영역) 계산
    let shadeDuration = sectionEtime - sectionStime - totalCutDuration;

    if (shadeDuration < 0) {
      alert(t('편집 구간을 선택해주세요.'));
      return;
    }

    const cloneEditArea = editArea.cloneNode(true);

    dispatch(addListsAction(listArr, sectionIdx));
    dispatch(addCutAction(playArr, sectionIdx));
    dispatch(addCutSectionAction(cloneEditArea, sectionIdx));

    if (totalCutDuration <= 0) {
      // 컷 편집한게 없으면 그림자 영역도 0
      shadeDuration = 0;
    }

    const shadeList = [];
    if (editMode === 'section') {
      // 구간 편집기는 그림자 영역으로 LIMIT시간 체크
      dispatch(setShadeDuration(shadeDuration, sectionIdx)); // 편집하고 없어질 그림자 영역 dispatch

      // Shade_area영역
      const shadeArea = document.querySelectorAll(
        `.${CSS_SHADES_AREA}`,
      ) as NodeListOf<HTMLElement>;
      for (const el of shadeArea) {
        const left = getStyleLeft(el);

        const sTime = getProgressBarTimeByPx(
          left,
          getWidth(wrapRef.current),
          sectionStime,
          sectionEtime,
        );
        const eTime = getProgressBarTimeByPx(
          left + getWidth(el),
          getWidth(wrapRef.current),
          sectionStime,
          sectionEtime,
        );

        const startTime = Number(sTime.toFixed(2));
        const endTime = Number(eTime.toFixed(2));
        const duration = Number((eTime - sTime).toFixed(2));

        if (duration < 1) continue; // 1초 미만은 제외

        shadeList.push({
          startTime,
          endTime,
          duration,
        });
      }
    }
    dispatch(addShadesAction(shadeList, sectionIdx));

    // 컷 정보 ADD 할 때 마다 히스토리 저장함
    // 단, Undo/Redo 인 케이스에는 저장안함
    if (!isHistroy) {
      dispatch(setAction(cloneEditArea));
    }
  };

  /**
   * 다음 섹션 재생 index구하고 dispatch하는 함수
   * @param cutLists 편집 리스트 영역
   * @param sectionIdx 섹션 인덱스
   * @param editMode 편집 모드
   */
  const setDispatchSection = (
    cutLists: TCutLists[][],
    sectionIdx: number,
    editMode: string,
  ) => {
    let nextIdx = sectionIdx + 1;

    if (editMode === 'web') {
      // 웹 편집기는 플레이어 재생 시에, 편집한 영역의 섹션으로 재생시킴
      if (!cutLists[nextIdx]) {
        if (nextIdx === cutLists.length) {
          // 다음 섹션에 편집한게 없을 경우,

          // 이미 paused면 리턴
          if (!videoDOM) return;
          if (getPausedState(videoDOM)) return;

          // 다음 섹션에 편집 영역 없을 경우에는
          // 해당 섹션 그림자 영역 클릭 헀을 때 일시 정지 시킴
          videoDOM.pause();
          dispatch(pauseAction());
          dispatch(seekingAction(playingTime));
          return;
        }

        for (let i = nextIdx; i < cutLists.length; i++) {
          if (cutLists[i]) {
            nextIdx = i;
            break;
          }
        }
      }
    }

    dispatch(setNextSectionAction(nextIdx));
  };

  // .div_wrap_editor 이벤트들 바인딩
  // useEventListener hooks 구현은 오픈소스 참조하여 ts아닌 js로 함..)
  useEventListener('mousedown', onMouseDown);
  useEventListener('mousemove', onMouseMove);
  useEventListener('mouseup', onMouseUp);
  useEventListener('mouseleave', onMouseLeave, wrapRef.current as any);

  return (
    <EditWrap
      wrapRef={wrapRef}
      innerRef={innerRef}
      hoverRef={hoverRef}
      playHeadRef={playHeadRef}
      flowRef={flowRef}
      playHead={playHead}
      flowHead={flowHead}
      wrapHover={wrapHover}
      // cut={cut}
      onClickDivision={onClickDivision}
      // shadeStyle={shadeStyle}
      divideBtn={divideBtn}
      displayEditWarn={displayEditWarn}
    />
  );
};

export default EditWrapContainer;
